// This file was generated with `npm run icons:generate`. Don’t edit directly.
import Icon from 'tailwind/components/Icon/Icon';
import { IconOuterProps } from 'tailwind/components/Icon/Icon.types';

const UtilityStrokeArrowLeftMediumIcon = (props: IconOuterProps) => (
  <Icon {...props} viewBox="0 0 32 32">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.65652 15.6516C5.46126 15.8469 5.46126 16.1635 5.65652 16.3587L12.193 22.8952C12.3882 23.0904 12.7048 23.0904 12.9001 22.8952C13.0953 22.6999 13.0953 22.3833 12.9001 22.1881L7.21712 16.5051L26.0517 16.5051C26.3279 16.5051 26.5517 16.2812 26.5517 16.0051C26.5517 15.729 26.3279 15.5051 26.0517 15.5051L7.21724 15.5051L12.9001 9.82226C13.0953 9.627 13.0953 9.31042 12.9001 9.11516C12.7048 8.9199 12.3882 8.9199 12.193 9.11516L5.65652 15.6516Z"
      fill="var(--icon-color-main)"
    />
  </Icon>
);

export default UtilityStrokeArrowLeftMediumIcon;
